import React, { useState } from "react";
import { Image01 } from "@untitledui/icons/Image01";
import { ClockRewind } from "@untitledui/icons/ClockRewind";
import { TypeSquare } from "@untitledui/icons/TypeSquare";
import { motion } from "framer-motion";
import { RightSlideAbsoluteAnimation } from "../../../animations/animations";
import {
  ActionsWrapper,
  CloseButton,
  EditionTypeOption,
  Header,
  ModalWrapper,
  Title,
  PlacementsContainer,
  StickyFooter
} from "./EditionModal.styled";
import { XIcon } from "../../../Components/Icons";
import TextEdition from "./text-edition/TextEdition";
import ImageEdition from "./image-edition/ImageEdition";
import { FlexWrapper } from "../AdAssistant.styled";
import EditionPreview from "./edition-preview/EditionPreview";
import AdAssistantStore from "../AdAssistantStore";
import { withRefluxStore } from "../../../Stores";
import PreviewPlacements from "../preview-placements/PreviewPlacements";
import LogoEdition from "./logo-edition/LogoEdition";

import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";
import { Store__System } from "@talentbait/shared-components";
import VersionHistory from "./version-history/VersionHistory";
import { useTranslation } from "react-i18next";
import { useKeyDown } from "../../../hooks/use-keydown-event.hook";
import ContinueButton from "../../../Components/ContinueButton/ContinueButton";

export const orientationsOptions = [
  { value: "all", label: "All" },
  { value: "vertical", label: "Vertical" },
  { value: "portrait", label: "Portrait" },
  { value: "landscape", label: "Landscape" }
];

const EditionModal = ({
  toggleModal,
  editionModalType,
  saveNewImage,
  saveNewInputProps,
  saveNewData,
  // Store
  currentAd
}) => {
  const { t } = useTranslation();

  const [orientationSelected, setOrientationSelected] = useState(orientationsOptions[0]);
  const [editionType, setEditionType] = useState(editionModalType);

  const mediaAssetsAd = currentAd.mediaAssets;

  const isVideoAsset = mediaAssetsAd.type === "video";
  const selectedCurrentAdAsset = isVideoAsset
    ? mediaAssetsAd.vertical.inputProps.video
    : mediaAssetsAd.vertical.inputProps.backgroundImage;

  const handleOrientationChange = (selectedOrientation) => {
    setOrientationSelected(selectedOrientation);
  };

  const handleSaveNewInputProps = (newInputs, showNotification) => {
    saveNewInputProps(newInputs, showNotification, orientationSelected);
  };

  const handleCloseModal = ({ type }) => {
    toggleModal({ type });

    if (currentAd.status !== "temp" && currentAd.status !== "unused") {
      ActionsAdAssistant.updateAd(
        { isLocked: false, lockedBy: null, lockedUserId: null },
        currentAd.id
      );
    }
  };

  useKeyDown(["Escape"], () => handleCloseModal({}));

  return (
    <motion.div {...RightSlideAbsoluteAnimation}>
      <Header>
        <ActionsWrapper>
          <Title>{t("Edit Ad")}</Title>
        </ActionsWrapper>
        <CloseButton onClick={handleCloseModal}>
          <XIcon />
        </CloseButton>
      </Header>
      <ModalWrapper>
        <FlexWrapper gap={11} direction={"column"} align={"flex-start"} width={"max-content"}>
          <PreviewPlacements
            orientationsOptions={orientationsOptions}
            orientationSelected={orientationSelected}
            handleOrientationChange={handleOrientationChange}
          />
          <EditionPreview editedAd={currentAd} orientationSelected={orientationSelected} />
        </FlexWrapper>
        <FlexWrapper gap={11} direction={"column"} align={"flex-start"}>
          <PlacementsContainer>
            <EditionTypeOption
              selected={editionType === "image"}
              onClick={() => setEditionType("image")}
            >
              <Image01 size={16} color="var(--primary-black)" />
              <span>Image</span>
            </EditionTypeOption>
            <EditionTypeOption
              selected={editionType === "text"}
              onClick={() => setEditionType("text")}
            >
              <TypeSquare size={16} color="var(--primary-black)" />
              <span>Text</span>
            </EditionTypeOption>
            <EditionTypeOption
              selected={editionType === "logo"}
              onClick={() => setEditionType("logo")}
            >
              <Image01 size={16} color="var(--primary-black)" />
              <span>Logo</span>
            </EditionTypeOption>
            <EditionTypeOption
              selected={editionType === "version-history"}
              onClick={() => setEditionType("version-history")}
            >
              <ClockRewind size={16} color="var(--primary-black)" />
              <span>{t("Version History")}</span>
            </EditionTypeOption>
          </PlacementsContainer>
          <FlexWrapper gap={0} direction={"column"} align={"flex-start"}>
            {editionType === "text" && (
              <TextEdition saveNewData={saveNewData} saveNewInputProps={handleSaveNewInputProps} />
            )}
            {editionType === "image" && (
              <ImageEdition
                saveNewImage={saveNewImage}
                selectedCurrentAdAsset={selectedCurrentAdAsset}
              />
            )}
            {editionType === "logo" && (
              <LogoEdition
                saveNewInputProps={handleSaveNewInputProps}
                currentAd={currentAd}
                mediaAssets={mediaAssetsAd}
                orientationSelected={orientationSelected}
              />
            )}
            {editionType === "version-history" && <VersionHistory adId={currentAd.id} />}

            {editionType !== "version-history" && (
              <StickyFooter>
                <ContinueButton onClick={handleCloseModal}>{t("Done")}</ContinueButton>
              </StickyFooter>
            )}
          </FlexWrapper>
        </FlexWrapper>
      </ModalWrapper>
    </motion.div>
  );
};

export default withRefluxStore(EditionModal, [AdAssistantStore, Store__System], ["currentAd"]);
